"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setSessionReplayCookie = exports.initSessionReplay = exports.continueExistingSessionReplay = exports.SESSION_REPLAY_EXPERIMENT_KEY = exports.SESSION_REPLAY_COOKIE = void 0;
var _environment = _interopRequireDefault(require("../environment"));
var _storage = require("../storage");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// Mixpanel Session Replay cookie
var SESSION_REPLAY_COOKIE = exports.SESSION_REPLAY_COOKIE = 'msr';
var SESSION_REPLAY_EXPERIMENT_KEY = exports.SESSION_REPLAY_EXPERIMENT_KEY = 'session-replay-sample-rate';
var setSessionReplayCookie = exports.setSessionReplayCookie = function setSessionReplayCookie() {
  var cookieDurationDays = 0.0035; // ~5 minutes
  (0, _storage.setCookie)(SESSION_REPLAY_COOKIE, 'active', cookieDurationDays);
};
var initSessionReplay = exports.initSessionReplay = function initSessionReplay(condition) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var environment = (0, _environment.default)();
  var devOverride = options.devOverride,
    isExistingSession = options.isExistingSession;
  var isOfficeIp = (0, _storage.getCookie)('zolaOfficeIp') === 'true';
  var isBlockedUserAgent = window.navigator.userAgent.indexOf('BingPreview') > -1 || window.navigator.userAgent.indexOf('HeadlessChrome') > -1 || window.navigator.userAgent.indexOf('TreoWorker') > -1 || window.navigator.userAgent.toLowerCase().indexOf('bot') > -1;
  var allowSessionReplay = !isOfficeIp && !isBlockedUserAgent && environment === 'production' || devOverride;
  var shouldStartSession = Boolean(condition && allowSessionReplay);
  if (shouldStartSession) {
    // Only set or reset the cookie if we are starting a new session
    // We want to limit the session duration since each continuation is billed
    if (!isExistingSession) setSessionReplayCookie();
    if (typeof window !== 'undefined' && window.mixpanel) {
      window.mixpanel.start_session_recording();
    }
  }
};
var continueExistingSessionReplay = exports.continueExistingSessionReplay = function continueExistingSessionReplay(devOverride) {
  var hasSessionReplayCookie = Boolean((0, _storage.getCookie)(SESSION_REPLAY_COOKIE));
  if (hasSessionReplayCookie) {
    initSessionReplay(true, {
      devOverride: devOverride,
      isExistingSession: true
    });
  }
};